import { useSelector } from "react-redux";
import { useDemoDataToggle } from "../../../User/hooks/useDemoDataToggle";

export const useIsStripeConnected = () => {
  const { businessAccount } = useSelector((state) => state.user);
  const { userInfo } = useSelector((state) => state.auth);
  const { isShowDemoData } = useDemoDataToggle();

  if (userInfo?.is_demo || userInfo?.is_external_demo_mode) {
    return isShowDemoData;
  }

  return isShowDemoData || !!businessAccount?.connected_payment_processors?.includes("stripe");
};
